import UTIF from 'utif'

interface AssetUpload {
  id?: string
  asset: {
    masterForGroupId: string | null
    groupId: string
  }
}

interface Label {
  name: string
  systemName: string
}

export function uploaderIsDisabled(uploader: any) {
  return !!(
    !uploader.asset?.id ||
    uploader.shouldPrepare ||
    uploader.isPreparing ||
    uploader.shouldCreate ||
    uploader.isCreating ||
    uploader.shouldUpdate ||
    uploader.isUpdating ||
    uploader.shouldDelete ||
    uploader.isDeleting ||
    uploader.error
  )
}

export function generateId(): string {
  // Would prefer using uuid here, but since this is used to
  // identify groups all the way to editing desks through our
  // APIs I dont want to completely change the syntax from numbers
  // to long strings with characters at this point.
  return Math.round(Math.random() * Math.pow(10, 12)).toString()
}

export function createGroups(uploaders: AssetUpload[]) {
  const groups: { [k: string]: AssetUpload[] } = {}
  for (const uploader of uploaders) {
    const groupId = uploader.asset.groupId || generateId()
    if (!groups[groupId]) {
      groups[groupId] = []
    }
    groups[groupId].push(uploader)
  }
  return Object.entries(groups)
}

export function translateLabel(
  label: string,
  preDefinedLabels: Label[]
): string {
  return preDefinedLabels.find((l) => l.systemName === label)?.name || label
}

export function getTiffThumb(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        if (!e.target || !e.target.result) return
        const buffer = e.target.result as ArrayBuffer
        const ifds = UTIF.decode(buffer)
        if (ifds[0]) {
          UTIF.decodeImage(buffer, ifds[0])
          if (ifds[0].width && ifds[0].height) {
            const rgba = UTIF.toRGBA8(ifds[0])
            const canvas = document.createElement('canvas')
            canvas.width = ifds[0].width
            canvas.height = ifds[0].height
            const context = canvas.getContext('2d')
            if (context) {
              const imageData = context.createImageData(
                ifds[0].width,
                ifds[0].height
              )
              let data
              for (let i = 0; i < rgba.length; i++) {
                data = rgba[i]
                imageData.data[i] = data
              }
              context.putImageData(imageData, 0, 0)
              resolve(canvas.toDataURL())
            }
          }
        }
      }

      fileReader.readAsArrayBuffer(file)
    } catch (e) {
      reject(e)
    }
  })
}
